import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import SignInModal from 'apps/signIn/main/modal';
import { modalStore } from 'apps/modals/app';
import { WrapperSignInForm } from 'apps/signIn/styles';

import { ComponentRegistry } from 'core/registry';

import CompactSignUp from './CompactSignUp';

const SignUpModal = observer(props => {
  // this replaces 'extends Modal' if this was written as a class component.
  useEffect(() => {
    setTimeout(() => {
      props.fadeIn();
    }, 300);
  }, []);

  const handleSignIn = () => {
    modalStore.SetModalComponent(
      SignInModal,
      { signUpModal: SignUpModal },
      modalStore.onClose,
    );
  };

  return (
    <WrapperSignInForm>
      <CompactSignUp isModal />
      <div
        style={{
          alignSelf: 'stretch',
          textAlign: 'center',
        }}
      >
        <span>
          Already a member?{' '}
          <a
            href=''
            onClick={e => {
              e.preventDefault();
              handleSignIn();
            }}
          >
            Log in
          </a>
        </span>
      </div>
    </WrapperSignInForm>
  );
});

SignUpModal.propTypes = {
  fadeIn: PropTypes.func,
};

ComponentRegistry.add('modals.SignUpModal', SignUpModal);

export default SignUpModal;
